import { render, staticRenderFns } from "./shiba.vue?vue&type=template&id=25b60333&scoped=true"
import script from "./shiba.vue?vue&type=script&lang=js"
export * from "./shiba.vue?vue&type=script&lang=js"
import style0 from "./shiba.vue?vue&type=style&index=0&id=25b60333&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b60333",
  null
  
)

export default component.exports